import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import BeOurGuest from "@/pages/home/components/BeOurGuest";
import MoreThanStay from "@/pages/home/components/MoreThanStay";
import WhyDifferent from "@/pages/home/components/WhyDifferent";
import ThreePillars from "@/pages/home/components/ThreePillars";
import BausteineSection from "@/pages/home/components/BausteineSection";
import KuebelwagenTile from "@/pages/home/components/KuebelwagenTile";
import ReserveBanner from "@/pages/home/components/ReserveBanner";
import AboutSection from "@/pages/home/components/AboutSection";
import GuestReviews from "@/pages/home/components/GuestReviews";
import InfoEvents from "@/pages/home/components/InfoEvents";
import VoucherPage from "@/pages/voucher/page";
import ExcursionVoucherPage from "@/pages/excursion-voucher/page";

export default function Home() {
  const [searchParams] = useSearchParams();
  const voucherId = searchParams.get("voucher");
  const excursionId = searchParams.get("excursion");

  if (voucherId) {
    return <VoucherPage />;
  }

  if (excursionId) {
    return <ExcursionVoucherPage />;
  }

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <BeOurGuest />
        <ThreePillars />
        <WhyDifferent />
        <BausteineSection />
        <KuebelwagenTile />
        <MoreThanStay />
        <AboutSection />
        <GuestReviews />
        <ReserveBanner />
        <InfoEvents />
      </main>
      <Footer />
    </div>
  );
}